import React from 'react';

import { Icon } from '@epoch-ui/components/Icon';
import { Button } from '@epoch-ui/components/Button';
import { useInviteGuestsModal } from '@event-editor/hooks/eventEditorState';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import { EventPublishScheduleStatus } from 'types/event.types';

export const GuestsDraftState: React.FC = () => {
  const event = useEditableEvent();
  const hasPublishSchedule = event.publishSchedule?.status === EventPublishScheduleStatus.SCHEDULED;

  return (
    <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-4">
      <h2 className="tw-m-0 tw-mb-1 tw-text-xl tw-font-medium tw-leading-7">Guests</h2>

      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-dashed tw-border-border-grey tw-bg-background tw-py-8">
        <div className="tw-space-y-4 tw-text-center tw-font-normal tw-leading-5 tw-text-muted-foreground">
          <Icon name="notepad-text" size={24} />
          {hasPublishSchedule ? (
            <div className="tw-text-sm tw-font-normal tw-leading-4 tw-text-muted-foreground">
              <p className="tw-m-0">Event is scheduled for publish</p>
              <p className="tw-m-0 tw-text-xs">
                You’ll be able invite guests after the event is published
              </p>
            </div>
          ) : (
            <p>Publish the event to start inviting guests</p>
          )}
        </div>
      </div>
    </div>
  );
};

type GuestsEmptyStateProps = {
  description?: string;
  action?: React.ReactNode;
};

export const GuestsEmptyState: React.FC<GuestsEmptyStateProps> = ({ description, action }) => {
  const event = useEditableEvent();
  const { open: openInviteGuestsModal } = useInviteGuestsModal();

  return (
    <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-items-start">
        <h2 className="tw-m-0 tw-mb-1 tw-flex-1 tw-text-xl tw-font-medium tw-leading-7">
          Guest list
        </h2>
        {action ??
          (!event.hasEnded && (
            <Button
              variant="secondary"
              size="xxs"
              className="tw-rounded-xl"
              onClick={() => openInviteGuestsModal()}
            >
              <Icon name="user-plus" size={16} className="tw-mr-1" />
              Invite guests
            </Button>
          ))}
      </div>

      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-dashed tw-border-border-grey tw-bg-background tw-py-8">
        <div className="tw-space-y-1 tw-text-center tw-font-normal tw-text-muted-foreground">
          <Icon name="user" size={24} />
          <p className="tw-m-0 tw-text-sm tw-leading-5">No guests yet</p>
          <p className="tw-m-0 tw-text-xs tw-leading-4">
            {description ?? 'Invite guests or share this event to get started'}
          </p>
        </div>
      </div>
    </div>
  );
};
